import React, { useEffect, useState } from "react";
import { FaPlusCircle } from "react-icons/fa";
import "../CarUpdate/style.css";
import "./style.css";
import { inp_chk_action, img_list_action } from "../Redux/reduxflow/action";
import { connect } from "react-redux";

function IputTypes(props) {
  const {
    inp_chk_action,
    pics,
    data,
    divindex,
    index_of,
    showCamFunction,
    onAddPhoto,
  } = props;

  useEffect(() => {
    if (typeof showCamFunction === "function") {
      showCamFunction(false);
    }
    // Parent owns camera mode; keep shell in sync when question UI is shown.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index_of]);

  const inpboxvaluehandler = async (e) => {
    const d = e.id;
    inp_chk_action({
      info: d,
      div: d,
      index: index_of,
    });
  };

  const choices = data?.choices || [];
  const selected = divindex[index_of];
  const selectedChoice = choices.find(
    (item) => String(item.id) === String(selected)
  );

  return (
    <div className="pi-check__question">
      <div className="pi-check__q-head">
        <p className="pi-inspection-label">Question</p>
        <h2>{data?.question || "Select an option"}</h2>
        <p>Choose the option that applies to this vehicle.</p>
        {selectedChoice ? (
          <div className="pi-check__selected-banner" role="status">
            <span>Selected</span>
            <strong>{selectedChoice.choice}</strong>
          </div>
        ) : (
          <div className="pi-check__selected-banner is-empty" role="status">
            <span>No selection yet</span>
            <strong>Tap an option below</strong>
          </div>
        )}
      </div>

      <div className="pi-check__choices" role="listbox" aria-label="Answers">
        {choices.map((item, id) => {
          const isActive = String(selected) === String(item.id);
          const tint = item.color || undefined;
          return (
            <button
              key={item.id || `${item.choice}-${id}`}
              type="button"
              role="option"
              aria-selected={isActive}
              className={`pi-check__choice${isActive ? " is-active" : ""}`}
              style={
                tint
                  ? {
                      background: isActive
                        ? tint
                        : `linear-gradient(0deg, rgba(255,255,255,0.72), rgba(255,255,255,0.72)), ${tint}`,
                    }
                  : undefined
              }
              onClick={() => inpboxvaluehandler(item, id)}
            >
              <span className="pi-check__choice-mark" aria-hidden />
              <span className="pi-check__choice-body">
                <span className="pi-check__choice-text">{item.choice}</span>
                {isActive ? (
                  <span className="pi-check__choice-badge">Selected</span>
                ) : null}
              </span>
            </button>
          );
        })}
      </div>

      <div className="pi-check__photos">
        <div className="pi-check__photos-head">
          <div>
            <strong>Reference photos</strong>
            <p>Optional images for this answer.</p>
          </div>
          <button
            type="button"
            className="pi-check__photo-add"
            onClick={() => {
              if (typeof onAddPhoto === "function") onAddPhoto();
            }}
          >
            <FaPlusCircle size={16} aria-hidden />
            Add photo
          </button>
        </div>
        <div className="pi-check__photo-grid">
          {index_of in pics
            ? pics[index_of].map((item, i) => (
                <img
                  key={`${item}-${i}`}
                  className="pi-check__photo"
                  src={item}
                  alt=""
                />
              ))
            : null}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  divindex: state.cardata.divindex,
  pics: state.cardata.pics,
});

const mapDispatchToProps = (dispatch) => {
  return {
    inp_chk_action: (response) => dispatch(inp_chk_action(response)),
    img_list_action: (response) => dispatch(img_list_action(response)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IputTypes);
